
//==============================================================================
// main.js
//
// This module executes top-to-bottom. Assumed entered once by webpack init.
// Exports a Backbone router.
//
// Lou Mauget Nov, 12, 2015.
//
//==============================================================================

import $ from 'jquery';

import 'bootstrap';
import 'bootstrap-table/src/bootstrap-table.js'


import 'jquery-ui';

import 'free-jqgrid';

import 'jquery-ui/ui/widgets/dialog.js';
import 'jquery-ui/ui/widgets/sortable.js';

import 'free-jqgrid/css/ui.jqgrid.css';
import 'free-jqgrid/js/jquery.jqgrid.min.js';

import RestService       from  'RestService';
import configService        from 'ConfigService';
import PopupWrapperService from 'PopupWrapperService';

//----------- Styles ==> ----------------------
import 'superfish/dist/css/superfish.css';
import 'bootstrap-treeview/src/css/bootstrap-treeview.css';
import 'spectrum-colorpicker/spectrum.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'animate.css';
import 'hover-min.css';
import 'main.css';
import 'spinner.css';
import 'pf.css';
import 'chat-bot.css';
import 'tours.css';
import 'designer.css';
import 'mobile/mobile-designer.css';
//----------- <== Styles ----------------------

import 'spectrum-colorpicker/spectrum.js';

// Importing libraries for submenu.
import 'bootstrap-submenu/dist/css/bootstrap-submenu.css';
import 'bootstrap-submenu/dist/js/bootstrap-submenu.js';

import 'bootstrap-table/dist/bootstrap-table.min.css';

//import 'jquery-migrate';

// BB stuff
import Backbone, {Model} from 'backbone';
import constants        from 'Constants.js';
import sequenceService 	from 'SequenceService.js';
import listService      from 'ListService.js';
import restService      from 'RestService.js';
import formAddService   from 'FormAddService.js';
import formSaveService  from 'FormSaveService.js';
import formUnloadService from 'FormUnloadService';
import notificationService  from 'NotificationService.js';
import util             from 'util/Util.js';

import DesignerView  	from 'DesignerView.js';
import BehaviorsView  	from 'BehaviorsView.js';
import WorkflowView  	from 'workflow/WorkflowView.js';
import ReportView  	    from 'ReportView.js';

import DesignerModel 	from 'DesignerModel.js';

import DashboardView  	from 'dashboard/DashboardView.js';
import DashboardModel 	from 'DashboardModel.js';

import LoginView  		from 'LoginView.js';
import LoginModel 		from 'login-model.js';
import SignUpView  		from 'SignUpView.js';
import SignUpModel 		from 'SignUpModel.js';
import ForgotPasswordView  		from 'ForgotPasswordView.js';
import ForgotPasswordModel 		from 'ForgotPasswordModel.js';
import ResetPasswordView  		from 'ResetPasswordView.js';
import ResetPasswordModel 		from 'ResetPasswordModel.js';

import _                from 'lodash';

import GreetingView  	from 'GreetingView.js';
import GreetingModel 	from 'greeting-model.js';

import TrialExpiredView from 'TrialExpiredView.js';
import TrialExpiredModel from 'trial-expired-model.js'

// Keyboard
import 'KeyboardController.js';
import undoService  from 'UndoService';
import gitsha from './gitsha.js';

import Spinner from "../../web_modules/spin/spin";

//-----------------------------------------------> sandbox

//-----------------------------  end sandbox <----

$.fn.spectrum.load = false;

if ( self !== top ) {
    throw 'Loading the application inside a frame is not allowed.';
}

sequenceService.resetSeq();
sequenceService.resetTabIndex();

const mountPoint = '<div id="content" class="disable-select"></div>';
const content = '#content';
$(document.body).html( mountPoint );

(() => {
    //Check if is a production environment then disable the JavaScript console, if not then display Git SHA information
    configService.promise.then(config => {
        if (config.isProduction !== false) { //The value must be explicitly defined as false, any other value will be taken as true
            window.console.assert = ()=> { };
            window.console.clear = ()=> { };
            window.console.count = ()=> { };
            window.console.error = ()=> { };
            window.console.group = ()=> { };
            window.console.groupCollapsed = ()=> { };
            window.console.groupEnd = ()=> { };
            window.console.info = ()=> { };
            window.console.log = ()=> { };
            window.console.table = ()=> { };
            window.console.time = ()=> { };
            window.console.timeEnd =()=> { };
            window.console.trace = ()=> { };
            window.console.warn = ()=> { };
        } else {
            gitsha();
        }
    });
})();

// TODO: hold this in the listService? Or the form?
const model = new DesignerModel();
const viewCache = {};

// Pre-instantiate main view with shared the model instance
( () => {
    listService.addMainView(constants.KIND_REPORT, new ReportView({model: new DesignerModel(), el: content}));
    listService.addMainView(constants.KIND_LAYOUT, new DesignerView({model: model, el: content}));
})();

String.prototype.toCamelCase = function() {
    return this.replace(/^([A-Z])|\s(\w)/g, function(match, p1, p2, offset) {
        if (p2) { return p2.toUpperCase(); }
        return p1.toLowerCase();
    });
};

// For todays date;
Date.prototype.today = function () {
    return ((this.getDate() < 10) ? "0" : "") + this.getDate() + "/" + (((this.getMonth() + 1) < 10) ? "0" : "") + (this.getMonth() + 1) + "/" + this.getFullYear();
}

// For the time now
Date.prototype.timeNow = function () {
    return ((this.getHours() < 10) ? "0" : "") + this.getHours() + ":" + ((this.getMinutes() < 10) ? "0" : "") + this.getMinutes() + ":" + ((this.getSeconds() < 10) ? "0" : "") + this.getSeconds();
}

// register jQuery extension
jQuery.extend(jQuery.expr[':'], {
    focusable: function (el, index, selector) {
        //return $(el).is('a, button, :input, [tabindex]');
        return $(el).is(':input,select,a,button,[tabindex]');
    }
});

var keyboardListenToRestoreProperty = '.property-pane input,.property-pane select,.property-pane a,.property-pane button';

$(document).on('focus', keyboardListenToRestoreProperty, function (e) {
    listService.lastActiveElementInProperties = $(e.target).attr('name');
    if (!listService.lastActiveElementInProperties) {
        console.log("There is no NAME attribute for selected property. Tab cannot be restored ", $(e.target));
    }
});

$(document).on('blur', keyboardListenToRestoreProperty, function (e) {
    listService.lastActiveElementInProperties = null;
});

$(document).on('keydown', keyboardListenToRestoreProperty, function (e) {
    var charCode = (typeof e.which === "number") ? e.which : e.keyCode;

    // if TAB or ENTER is pressed
    if (charCode === 9 || charCode === 13) {
        // Get all focusable elements on the property pane
        var $canfocus = $('.property-pane').find(':focusable');
        // Find next active element and focus
        var index = $canfocus.index(document.activeElement) + (e.shiftKey ? -1 : 1);
        if (index >= $canfocus.length) {
            index = 0;
        }

        // save it to be able to focus back
        listService.lastActiveElementInProperties = $($canfocus.eq(index)).attr('name');

        if (charCode === 13) {
            $canfocus.eq(index).trigger('focus');
        }
    }
});

// $(document).on('click', 'a', function(e) {
//     listService.linkClicked = true;
// });


window.onbeforeunload = function (event) {
    let e = event || window.event;
    let buttonMain = $("input[name='applyChanges']");
    let buttonForm = $("#applyChangesForm");
    let buttonReport = $("#applyChangesReport");
    if((undoService.hasChanges() || buttonMain.length > 0 || buttonForm.length > 0 || buttonReport.length > 0 )) {
        let message = "Are you sure you want to leave the page?";
        // // For IE and Firefox
        if (e) {
            e.returnValue = message;
        }

        // For Safari / chrome
        return message;
    }
    listService.isOnExport = false;
};

// Turn off listeners for all main views
function deafenMains() {
    listService.mainViews.map( ( view, k ) => {
        view.undelegateEvents();
        view.stopListening();
        if (k === constants.KIND_THUMBLIST) {
            view.remove();
        } else {
            view.removeUnused();
        }
    });
}

function displayLayout() {
    deafenMains();
    if ( !listService.getMainView( constants.KIND_LAYOUT ) ){
        listService.addMainView(constants.KIND_LAYOUT, new DesignerView({model: model, el: content}));
    }
    listService.getMainView( constants.KIND_LAYOUT ).render();
}

function displayMobileLayout() {
    deafenMains();
    if ( !listService.getMainView( constants.KIND_MOBILE ) ){
        listService.addMainView(constants.KIND_MOBILE , new DesignerView({model: model, el: content, designer: constants.KIND_MOBILE}));
    }
    listService.getMainView( constants.KIND_MOBILE).render();
}


function displayBehaviors(objectId, behaviorKey, selectedCommand = '') {
    deafenMains();
    if ( !listService.getMainView( constants.KIND_BEHAVIORS ) ){
        listService.addMainView(constants.KIND_BEHAVIORS, new BehaviorsView({model: model, el: content}));
    }
    const view = listService.getMainView( constants.KIND_BEHAVIORS );
    view.instanceToLoad = {
        behaviorKey: behaviorKey,
        objectId: objectId,
        selectedCommand: selectedCommand
    };

    view.render();
}

function displayWorkflow() {
    deafenMains();
    if ( !listService.getMainView( constants.KIND_WORKFLOW ) ){
        listService.addMainView(constants.KIND_WORKFLOW, new WorkflowView({model: model, el: content}));
    }
    listService.getMainView( constants.KIND_WORKFLOW ).render();
}

function displayReport() {
    deafenMains();
    if ( !listService.getMainView( constants.KIND_REPORT ) ){
        listService.addMainView(constants.KIND_REPORT, new ReportView({model: model, el: content}));
    }
    listService.getMainView( constants.KIND_REPORT ).render();
}


function sessionTimeout(appRouter) {
    deafenMains();
    formUnloadService.unloadForm();

    const SSO = util.isTrue(window.localStorage.getItem('DirectoryServiceEnabled'));

    if(!SSO){
        Backbone.history.loadUrl('login');
    }
    else{
        const SSOUrl = window.localStorage.getItem('DirectoryServiceGatewayURL');
        window.location.href = SSOUrl;
    }
    
}

function closeForm(appRouter) {
    deafenMains();
    restService.closeForm( listService.formBase.id ).then( (data) => {
        formUnloadService.unloadForm();
        Backbone.history.loadUrl('dashboard');
      
    });
}

function saveAndCloseForm(appRouter) {
    deafenMains();
    const closeAction = () => {
        restService.closeForm(listService.formBase.id).then(() => {
            formUnloadService.unloadForm();
            Backbone.history.loadUrl('dashboard');
        });
    };
    
    // Use the centralized handler from the service
    formSaveService.handleSave({ saveType: 'save', onClose: closeAction });
}

function clearPage() {
    $('div[role="dialog"]').remove();
    $('#formulaModal').remove();
    $('div.sp-container').remove();
    $('#select-field-dialog').remove();
}

// *PF-1574 Performs automatic login based on a loginToken saved on user profile from
// a previous login in which 'Remember Me option' was selected
function rememberLogin(currentProfile){
    configService.promise.then(config => {
        if (util.isTrue(restService.getProfile().HtmlDashboardEnabled)) {
            const apiHostUrl = config.apiHostUrl;
            const data = {}; 
            data['userName'] = currentProfile.EmailAddress;
            data['password'] = constants.DEFAULT_TOKEN;
            data['account'] = '';
            data['loginToken'] = currentProfile.LoginToken;
            data['createLoginToken'] = true;
            data['apiHostUrl'] = apiHostUrl;
            data['type'] = 5;
            data['token'] = constants.DEFAULT_TOKEN;
            data['directoryServiceUserName'] = constants.DEFAULT_TOKEN;
            data['anonymousAccountId'] = constants.DEFAULT_TOKEN;

            const callback = (error) => {
                if (error) {
                    $('.error-message').removeClass('hide');
                    $('.login-text').addClass('hide');
                    const view = new LoginView({ model: new LoginModel(), el: content });
                    view.render();
                } else {
                    util.processSettings();
                    Backbone.history.loadUrl('greeting');
                }
            };
            restService.login(data, callback);
        } else {
            const hostUrl = config.hostUrl;
            util.pf_main('100%', '100%', hostUrl + '/main.aspx', '&g=' + hostUrl);
        }
    });
}

function ssoLogin(currentProfile){
    configService.promise.then(config => {
        const hostUrl = config.hostUrl;
        const data = {};
        data['userName'] = constants.DEFAULT_VALUE;
        data['password'] = constants.DEFAULT_VALUE;
        data['account'] = constants.DEFAULT_VALUE;
        data['type'] = 0;
        data['token'] = currentProfile.t;
        data['createLoginToken'] = false;
        data['loginToken'] = constants.DEFAULT_VALUE;
        data['anonymousAccountId'] = constants.DEFAULT_VALUE;
        data['directoryServiceUserName'] = constants.DEFAULT_VALUE;

        if(currentProfile.r !== ''){
            listService.logoutRedirect = currentProfile.r;
        }

        const callback = ( error )=>{
            if(error){
                $('.error-message').removeClass('hide');
                $('.login-text').addClass('hide');
                const view = new LoginView({model: new LoginModel(), el: content});
                view.render();
            } else {
                util.processSettings();
                const profile = restService.getProfile();
                if (util.isTrue(profile.HtmlDashboardEnabled)){
                    Backbone.history.loadUrl('greeting');
                }else{
                    util.pf_main('100%', '100%', hostUrl + '/main.aspx', '&g=' + hostUrl + '&t=' + restService.getToken() + '&u=' + restService.getProfile().AccountName);
                }
            }
        };
        restService.login(data, callback);
    });
}

function resetPasswordLogin(profile){
    configService.promise.then(config => {
        const hostUrl = config.hostUrl;
        const data = {};

        data['account'] = constants.DEFAULT_VALUE;
        data['userName'] = profile.e;
        data['password'] = profile.h;
        data['directoryServiceUserName'] = constants.DEFAULT_VALUE;
        data['token'] = constants.DEFAULT_VALUE;
        data['anonymousAccountId'] = constants.DEFAULT_VALUE;
        data['type'] = 4;
        data['createLoginToken'] = false;
        data['loginToken'] = constants.DEFAULT_VALUE;
        data['resetPassword'] = true;

        const callback = ( error ) => {
            let code = 0;
            if (error) {
                code = error.CODE;
            }

            const viewError = new ResetPasswordView( { model: new ResetPasswordModel({ code: code.toString() }), el: content } );
            viewError.render();
        };

        restService.login(data, callback);
    });
}

function readParamsSSO(params){
    let currentProfile = {c : '', t : '', r : ''};
    if(params){
        let paramsDecoded = "";
        try {
            paramsDecoded = window.atob(params.split('utc=')[1]);
        } catch (err){//retroCompatability with SSO < 6.1.2.9
            paramsDecoded = params;
        }
        
        _.each(
            _.map(decodeURI(paramsDecoded).split(/&/g),function(el,i){
                var aux = el.split('='), o = {};
                if(aux.length >= 1){
                    var val = undefined;
                    if(aux.length === 2){
                        val = aux[1];
                    }
                    o[aux[0]] = val;
                }
                return o;
            }),
            function(o){
                _.extend(currentProfile,o);
            }
        );
        listService.gatewayUser = currentProfile.u;
    }
    return currentProfile;
}

function readParamsResetPassword(params){
    let data = {e : '', h : '', b: ''};
    if(params){
        _.each(
            _.map(decodeURI(params).split(/&/g),function(el,i){
                var aux = el.split('='), o = {};
                if(aux.length >= 1){
                    var val = undefined;
                    if(aux.length === 2){
                        val = aux[1];
                    }
                    o[aux[0]] = val;
                }
                return o;
            }),
            function(o){
                _.extend(data,o);
            }
        );
    }
    return data;
}

function parseQueryString(queryString){
    var params = {};
    if(queryString){
        _.each(
            _.map(decodeURI(queryString).split(/&/g),function(el,i){
                var aux = el.split('='), o = {};
                if(aux.length >= 1){
                    var val = undefined;
                    if(aux.length === 2) {
                        val = aux[1];
                    }
                    o[aux[0]] = val;
                }
                return o;
            }),
            function(o){
                _.extend(params,o);
            }
        );
    }
    return params;
}

function isUserLoggedIn(){
    return util.isLoggedIn && util.isLoggedIn.toLowerCase() !== 'false';
}

function getAppCustomization(){

    var enable = localStorage.getItem("enableCustomization");
    if(util.isTrue(enable)){
        constants.APP_NAME = localStorage.getItem("appName");
        var primaryColor = localStorage.getItem("primaryColor");
        var secondaryColor = localStorage.getItem("secondaryColor");
        constants.APP_LOGO = localStorage.getItem("logo");
        changeColor(primaryColor, secondaryColor);
    }
}

//changeColor();

function changeColor(primary, secondary){
    var r = document.querySelector(':root');
    r.style.setProperty('--main-primary', primary);
    const lighterColor = util.newShade(primary, 100);

    r.style.setProperty('--main-secondary', lighterColor);
    r.style.setProperty('--mobile-buttons', secondary);
}


getAppCustomization();

function changeAppName(){
    document.title = constants.APP_NAME;
}

//List of routes that DOESN'T require the user to be logged in
const securityExceptionRoutes = [ 'loginRoute', 'signUpRoute', 'tbHelpRoute', 'dbHelpRoute', 'ssoRoute', 'forgotPasswordRoute', 'resetPasswordRoute', 'trialExpiredRoute' ];
//List of routes that doesn't need to be validated in logic for undoService.hasChanges
const hasChangesExceptionRoutes = [ 'behaviorsRoute', 'workflowRoute' ];

//============================================================
// Create the router
//============================================================
const AppRouter = Backbone.Router.extend({
    initialize: function(options) {
    },
    execute: function(callback, args, name) {
        //Security check
        if (!securityExceptionRoutes.includes(name) && !isUserLoggedIn()){
            util.navigateToLogin();
            return false;
        }

        let buttonMain = $("input[name='applyChanges']");
        let buttonForm = $("#applyChangesForm");
        let buttonReport = $("#applyChangesReport");
        let isOnEditor = listService.currentForm !== undefined;

        if (name !== 'loginRoute') { // PF-1951 validation does not apply when navigating to Login
            // PF-1951 Validation for changes that are on the dashboard
            if (!listService.wentBackAlready && !isOnEditor
                && (undoService.hasChanges() || buttonMain.length > 0 || buttonForm.length > 0 || buttonReport.length > 0)) {
                listService.wentBackAlready = true;
                listService.linkClicked = false;
                window.history.forward();
                window.location.assign('');
                return false;
            }

            // PF-1951 Validation for changes that are on the editor. Going back only by hitting back button.
            else if (!listService.wentBackAlready && isOnEditor && !listService.linkClicked
                && (undoService.hasChanges() || buttonMain.length > 0 || buttonForm.length > 0 || buttonReport.length > 0) && !hasChangesExceptionRoutes.includes(name)) {
                listService.wentBackAlready = true;
                listService.linkClicked = false;
                window.history.forward();
                window.location.assign('');
                return false;
            }
            // PF-1951 If was already executed initialize control variables.
            else if (listService.wentBackAlready) {
                listService.linkClicked = false;
                listService.wentBackAlready = false;
                return false;
            }
        }
        // PF-1951 Reinitialization and default functionality if no validations were entered.
        listService.linkClicked = false;
        listService.wentBackAlready = false;
        return callback && callback.apply(this,args);
    },
    routes: {
        'login'     : 'loginRoute',
        'sign-up'   : 'signUpRoute',
        'greeting'  : 'greetingRoute',
        'trialExpired'  : 'trialExpiredRoute',
        'dashboard' : 'dashboardRoute',
        'edit'      : 'editorRoute',
        'mobile'    : 'mobileRoute',
        'editload'  : 'editLoadRoute',
        'behaviors' : 'behaviorsRoute',
        'behaviors/:objectId/:behaviorKey' : 'behaviorsRoute',
        'behaviors/:objectId/:behaviorKey/:selectedCommand' : 'behaviorsRoute',
        'workflowmain'  : 'workflowRoute',
        'report'    : 'reportRoute',
        'tbhelp'    : 'tbHelpRoute',
        'dbhelp'    : 'dbHelpRoute',
        'save'      : 'saveRoute',
        'newVersion': 'newVersionRoute',
        'saveAsNew' : 'saveAsNewRoute',
        'addForm'   : 'addFormRoute',
        'close'     : 'closeForm',
        'saveAndClose'     : 'saveAndCloseForm',
        'forgotPassword'     : 'forgotPasswordRoute',
        'resetPassword?*params'     : 'resetPasswordRoute',
        'sessionTimeout': 'sessionTimeout',
        'sso?*params' : 'ssoRoute',
        // 'testReport' : 'openTestReportRoute',

        // 'saveReport' :'saveReportRoute',
        // 'saveReport' :'saveCurrentReportAsNewRoute',

        // Backbone will try to match following route  first//
        '*default'  : 'loginRoute'
    }
});

const appRouter = new AppRouter();


/*
appRouter.on('route:openTestReportRoute', function( actions ){

    formLoadService.loadReport( '18898', 0, 1).then( data => {
        console.log(`REPORT raw load:`, data);
        notificationService.success( data );
    });

});
*/


// appRouter.on('route:saveReportRoute', function (actions) {
//     formSaveService.saveCurrentReport( options ).then(msg => {
//         notificationService.success( msg );
//     }, ( errMsg ) =>{
//         notificationService.error( errMsg );
//     });
// });
//
//
// appRouter.on('route:saveCurrentReportAsNewRoute', function( actions ){
//
//     formSaveService.saveCurrentReportAsNew( options ).then(msg => {
//         notificationService.success( msg );
//     }, ( errMsg ) =>{
//         notificationService.error( errMsg );
//     });
//
// });

appRouter.on('route:sessionTimeout', function() {
    sessionTimeout(appRouter);
});

appRouter.on('route:closeForm', function() {
    closeForm(appRouter);
});

appRouter.on('route:saveAndCloseForm', function() {
    saveAndCloseForm(appRouter);
});

////----------- Designer Login page ---------
appRouter.on('route:loginRoute', function (actions) {
    clearPage();
    let data;
    let isRedirectingToLogin = false;
    const queryString = window.location.href;
    const url = new URL(queryString);
    const searchParams = url.searchParams;

    //PF-9936 Load app customization
    getAppCustomization();

    if (window.Tawk_API){
       window.Tawk_API.hideWidget();
    }

    // PF-4435 - Include parameter on default root
    // PF-4740 - Including validation of existing preloaded user so the router is not redirected to himself whenever an URL parameter is being placed.
    if(!sessionStorage.getItem("PreloadedUser")) {
        if (queryString.indexOf('?e=') > -1) { //Check if we have the user name in the query string
            const qsSplitted = queryString.split('?e=');
            const mails = qsSplitted[1].match(constants.REGEX_FIND_MAIL_ADDRESS);
            if (mails && mails.length > 0) {
                data = {e: mails[0]};
            }

            if (sessionStorage) { //We need to store in session the user name, redirect to login and remove the parameters from the URL
                sessionStorage.setItem("PreloadedUser", mails[0]);
                Backbone.history.loadUrl('login');
                isRedirectingToLogin = true;
            }
        }
    }

    
    if (!isRedirectingToLogin) {
        let _preloadedUser;
        if (sessionStorage) { //Check if there is a user name in session storage, if so then use it to populate the user name field on login form
            _preloadedUser = sessionStorage.getItem("PreloadedUser");
            sessionStorage.removeItem('PreloadedUser');
            if (_preloadedUser) {
                data = { e: _preloadedUser };
            }
        }

        let currentProfile = RestService.getProfile();
        if (!data && (currentProfile && currentProfile.LoginToken)) {
            rememberLogin(currentProfile);
        } else {
            const view = new LoginView({ model: new LoginModel(data), el: content });
            view.render();
            let elementToFocus = 'userName';
            if (data && data.e) {
                elementToFocus = 'password';
            }
            setTimeout(() => { $(`[name="${elementToFocus}"]`).trigger('focus'); }, 250);
        }
    }
});

////----------- Designer Login page ---------
appRouter.on('route:ssoRoute', function (params) {
    clearPage();
    const NULL_TOKEN = '-9223372036854775808';
    const currentProfile = readParamsSSO(params);
    if(!currentProfile.t || currentProfile.t == NULL_TOKEN){
        $('.error-message').removeClass('hide');
        $('.login-text').addClass('hide');
        const view = new LoginView({model: new LoginModel(), el: content});
        view.render();

        $('#errorMessageLabel').text(currentProfile.t != NULL_TOKEN ? constants.ERROR_MSG_SSO_LOGIN : constants.ERROR_MSG_SSO_LOGIN_USER_INVALID);
        $('.error-message').removeClass('hide');
        $('.login-text').addClass('hide');
    } else {
        ssoLogin(currentProfile);
    }
});

//----------- Designer signup page ---------
appRouter.on('route:signUpRoute', function (actions) {
    clearPage();
    const view = new SignUpView( { model: new SignUpModel(), el: content } );
    view.render();
});

//----------- Designer forgot password page ---------
appRouter.on('route:forgotPasswordRoute', function (actions) {
    clearPage();
    const view = new ForgotPasswordView( { model: new ForgotPasswordModel(), el: content } );
    view.render();
});

//----------- Designer reset password page ---------
appRouter.on('route:resetPasswordRoute', function (params) {
    clearPage();
    const data = readParamsResetPassword(params);
    let view;
    if(data.h === ''){
        view = new LoginView({model: new LoginModel(data), el: content});
        view.render();
    }else{
        resetPasswordLogin(data);
    }
});

//----------- Designer greeting page ---------
appRouter.on('route:greetingRoute', function (actions) {
    clearPage();
    const key = 'GreetingView';

    if ( listService.userProfile.GettingStartedFormId && util.isTrue(listService._userSettings.get('_maShGS'))) {
        if (sessionStorage.getItem('timesGreetingWindowOpened') === '0') {
            // const greetingModal = new GreetingView( { model: new GreetingModel() } );
            // greetingModal.render();

            sessionStorage.setItem('timesGreetingWindowOpened', 1);
        }
    }

    viewCache[key] = viewCache[key] || new DashboardView( { model: new DashboardModel({pfVersion: constants.PF_VERSION }), el: content } );
    viewCache[key].render();
});

//----------- Designer trial expired page ---------
appRouter.on('route:trialExpiredRoute', function (actions) {
    clearPage();
    const trialExpiredModal = new TrialExpiredView( { model: new TrialExpiredModel(), el: content } );
    trialExpiredModal.render();
});

//----------- Dashboard  page ---------
appRouter.on('route:dashboardRoute', function (actions) {
    // Following Caching on Greeting Route if not a double view is rendered.
    clearPage();
    const key = 'GreetingView';

    viewCache[key] = viewCache[key] || new DashboardView({ model: new DashboardModel({ pfVersion: constants.PF_VERSION }), el: content });
    viewCache[key].render();

    //PF-5501 set this flag to check when rendering the dashboard that it comes from closing a form/report
    const form = listService.dashboardLayout.mainPanelView;
    if(form){
        form.model.set('closedForm', true, {silent:true});
    }    
});

//----------- Layout main panel ---------
appRouter.on('route:editorRoute', function (actions) {
    clearPage();
    displayLayout();
});

//----------- Mobile Layout main panel ---------
appRouter.on('route:mobileRoute', function (actions) {
    clearPage();
    displayMobileLayout();
});


//----------- Load and edit layout main panel --------- DUPE?
appRouter.on('route:editLoadRoute', function (actions) {
    clearPage();
    displayLayout();
});

//----------- Behaviors main panel ---------
appRouter.on('route:behaviorsRoute', function (objectId, behaviorKey) {
    clearPage();
    if (listService.useBehaviorId){
        displayBehaviors(listService.behaviorId, 'workflow');
        listService.useBehaviorId = false;
    }else{
      displayBehaviors(objectId, behaviorKey);
    }
});

//----------- Workflow main panel ---------
appRouter.on('route:workflowRoute', function (actions) {
    clearPage();
    displayWorkflow();

});

//----------- Report main panel ---------
appRouter.on('route:reportRoute', function (actions) {
    clearPage();
    displayReport();
});

//----------- toolbox help  ---------
appRouter.on('route:tbHelpRoute', function (actions) {
    //window.open('https://www.perfectforms.com/help/index2.php?id=fd_l_m');
    PopupWrapperService.windowOpen( constants.APP_URL + '/help/index2.php?id=fd_l_m' ) ;
});

//----------- dashboard help  ---------
appRouter.on('route:dbHelpRoute', function (actions) {
    //window.open( 'https://www.perfectforms.com/help/index2.php?id=fdb_a' );
    PopupWrapperService.windowOpen( constants.APP_URL + '/help/index2.php?id=fdb_a' ) ;
});

//----------- Main menu save   ---------

function coreFormSave( options ) {
    formSaveService.saveCurrentForm( options ).then(msg => {
        notificationService.success( msg );
    }, ( errMsg ) =>{
        notificationService.error( errMsg );
    });
}

appRouter.on('route:saveRoute', function (actions) {
    coreFormSave( { isNewVersion: false } );
});

appRouter.on('route:newVersionRoute', function (actions) {
    coreFormSave( { isNewVersion: true } );
});

appRouter.on('route:addFormRoute', function (actions) {
    formAddService.newForm().then( (msg) =>{
        notificationService.success( msg );
    }, ( errMsg ) =>{
        notificationService.error( errMsg );
    });
});

appRouter.on('route:saveAsNewRoute', function (actions) {
    formSaveService.saveCurrentFormAsNew().then( (msg) =>{
        notificationService.success( msg );
    }, ( errMsg ) =>{
        notificationService.error( errMsg );
    });
});

// ... end of router section
//============================================================
 Backbone.history.start();


export default appRouter; 
